import { render } from "./ApprovalBeforeRemoving.vue?vue&type=template&id=663a7b51"
import script from "./ApprovalBeforeRemoving.vue?vue&type=script&lang=js"
export * from "./ApprovalBeforeRemoving.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__